import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { PapiDeviation } from '@wix/da-papi-types';
import ThumbIconButton from '@wix/da-ds/pkg/thumbs/ThumbIconButton';
import type { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useFaveButton } from '../../../../FaveButton/useFaveButton';
import { useOverlayContext } from '../../../hooks/useOverlayContext';

interface Props {
  deviation: PapiDeviation;
  showStatNumbers?: boolean;
  iconSizeOverride?: IconSize;
  iconShapeSize?: IconSize.MEDIUM | IconSize.SMALLER;
  className?: string;
}

const FaveControl: React.FC<Props> = ({
  deviation,
  showStatNumbers = true,
  iconSizeOverride,
  iconShapeSize,
  className,
}) => {
  const { t } = useTranslation();
  const buttonRef = useRef<HTMLElement | null>(null);
  const { showStats } = useOverlayContext(deviation);
  const {
    isFavourite,
    faveCount,
    onClick: onFaveClick,
    biData,
  } = useFaveButton(deviation);

  const handleClick = useCallback(() => {
    onFaveClick();
    if (buttonRef.current) {
      buttonRef.current.blur();
    }
  }, [onFaveClick]);

  const showStatValue = showStats && showStatNumbers && faveCount !== 0;

  return (
    <ThumbIconButton
      ref={buttonRef}
      className={className}
      iconSizeOverride={iconSizeOverride}
      iconShapeSize={iconShapeSize}
      type="fave"
      aria-label={t('deviationview.overlay.a11y.favourite', {
        count: showStatValue ? faveCount : 0,
      })}
      isEngaged={isFavourite}
      showStatValue={showStatValue}
      statValue={faveCount}
      onClick={handleClick}
      biData={biData}
    />
  );
};
FaveControl.displayName = 'FaveControl';

export default FaveControl;
